import { Button, Dropdown } from 'rsuite';
import styled from 'styled-components';
import { VerifiedIcon } from '../../widgets/components/verified-icon';

export const LicensePlaceholderWrapper = styled.div`
  width: 100%;
  height: 520px;
  border-radius: 10px;
  background-color: #f6f9ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const PlaceholderMainText = styled.div`
  margin: 20px 84px;
  font-size: 20px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  color: rgba(0, 0, 0, 0.65);
`;

export const PlaceholderSubText = styled.div`
  font-size: 14px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.5);
`;

export const StreetAddress = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: normal;
  color: #101938;

  margin-bottom: 16px;

  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const VerifiedPropertyIcon = styled(VerifiedIcon)`
  font-size: 25px;
  flex-shrink: 0;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  p {
    margin: auto 0;
  }
`;

export const StatusGroupDropdown = styled(Dropdown)`
  & .rs-btn {
    width: 150px;
    height: 36px;
    color: white;
    background-color: #37a3bc;
    text-transform: capitalize;
  }

  & .rs-dropdown-menu,
  .rs-dropdown-item {
    width: 150px;
    text-transform: capitalize;

    div {
      width: fit-content;
    }
  }
`;

export const InfoBlock = styled.div`
  display: block;
  margin-bottom: 10px;
`;

export const InfoLabel = styled.p`
  margin: 0;
  font-size: 10px;
  font-weight: bold;
  color: #7f8fa4;
`;

export const InfoData = styled.p`
  line-height: 20px;
  margin: 0;
  text-align: left;
  text-decoration: ${(props) => (props.isImage ? 'underline' : null)};
  color: ${(props) => (props.isImage ? '#37A3BC' : null)};
`;

export const InfoPadding = styled.div`
  div:last-child {
    margin-bottom: 38px;
  }
`;

export const LicenseActionButton = styled(Button)`
  width: 150px;
  height: 36px;
`;
